export default __webpack_public_path__ + "static/media/cerebrisans-semibold.8c2b25fd.eot";